export enum MatchEventType {
  FOUL = 'FOUL',
  SHOT = 'SHOT',
  TIME_OUT = 'TIME_OUT',
}
